const IMPORTABLE_EXTENSIONS = [
  '.json',
  '.jsonld',
  '.html',
  '.htm',
  '.xhtml',
  '.docx',
  '.odt',
  // Not readable, but it reaches the server so the session can say why.
  '.doc',
  '.txt',
  '.md',
  '.markdown',
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.avif',
  '.heic',
  '.heif',
] as const;

export function isImportableRecipeFile(file: File): boolean {
  const name = file.name.toLowerCase();
  return IMPORTABLE_EXTENSIONS.some((ext) => name.endsWith(ext));
}

export function filterImportableRecipeFiles(files: Iterable<File>): File[] {
  return [...files].filter(isImportableRecipeFile);
}

export const IMPORT_FILE_ACCEPT =
  '.json,.jsonld,.html,.htm,.xhtml,.docx,.odt,.doc,.txt,.md,.pdf,.png,.jpg,.jpeg,.webp,.avif,.heic,.heif,' +
  'application/json,text/html,application/pdf,text/plain,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/vnd.oasis.opendocument.text,image/*';
